module.exports = __webpack_public_path__ + "static/media/queen.2cc136b6.svg";